// src/modules/sales/dashboard/widgets/shells/SalesFunnelChart.tsx
import { useQuery } from "@tanstack/react-query";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";
import { TrendingUp } from "lucide-react";
import { apiFetch } from "@/modules/shared/lib/api-client";
import { DEAL_STAGES } from "@/modules/sales/hooks/useCommercialDeals";

type Funnel = { stages: { stage: string; count: number }[] };

const STAGE_LABEL: Record<string, string> = Object.fromEntries(
  DEAL_STAGES.map((s) => [s.id, s.label])
);

function resolveLabel(stage: string): string {
  if (STAGE_LABEL[stage]) return STAGE_LABEL[stage];
  // Already a friendly CRM label (via backend COALESCE) — clip if too long
  if (stage.length > 20) return stage.slice(0, 18) + "…";
  return stage;
}

export function SalesFunnelChart() {
  const { data } = useQuery<Funnel>({
    queryKey: ["widget", "/sales/dashboard/funnel"],
    queryFn: () => apiFetch<Funnel>("/sales/dashboard/funnel"),
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });

  const chartData = (data?.stages ?? []).map((s) => ({
    ...s,
    label: resolveLabel(s.stage),
  }));

  return (
    <div className="ol-card flat col-span-2 flex flex-col gap-3">
      <div className="ol-card-head">
        <div className="ol-card-ic blue"><TrendingUp /></div>
        <div className="ol-card-title">
          <div className="ol-card-name"><span className="n">Funil de negócios</span></div>
        </div>
      </div>
      <div className="h-48">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" tick={{ fill: "#6b716b", fontSize: 11 }} />
            <YAxis allowDecimals={false} tick={{ fill: "#6b716b", fontSize: 11 }} />
            <Tooltip />
            <Bar dataKey="count" fill="#c6f04c" stroke="#0b0d0b" strokeWidth={1} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
